import { ReactNode } from 'react'
import { Link, useParams } from 'react-router-dom'
import { Creator, CreatorPausedReason, CreatorStatus } from '../../../gql/types'
import { CreatorRoutes } from '../../CreatorRoutes'

interface IProps {
  creator: Creator
}

const AccountPausedBanner = ({ children }: { children: ReactNode }) => {
  return (
    <div className='shadow ring-1 ring-black ring-opacity-5 rounded mt-6 p-6 bg-widget bg-white'>
      <div className='flex flex-col'>
        <h3 className='font-outfit text-xl'>Account paused</h3>
        <hr className='my-6' />
        <div className='text-base text-gray-500'>
          <p>{children}</p>
        </div>
      </div>
    </div>
  )
}

const AccountStatus = ({ creator }: IProps) => {
  const { id } = useParams()

  if (creator.status !== CreatorStatus.paused) {
    return null
  }

  if (creator.pausedReason === CreatorPausedReason.creatorRequested) {
    const profileLink =
      CreatorRoutes.accountProfile.replace(':id', `${id}`) + '#pause-account'

    return (
      <AccountPausedBanner>
        Your Clip account is paused. You can reactivate it anytime from your{' '}
        <Link
          to={profileLink}
          className='font-medium text-blue-600 hover:text-blue-500'
        >
          profile settings
        </Link>
        .
      </AccountPausedBanner>
    )
  }

  return (
    <AccountPausedBanner>
      Your Clip account is paused. Please contact us at{' '}
      <a
        href='mailto:hello@useclip.com'
        className='font-medium text-blue-600 hover:text-blue-500'
      >
        hello@useclip.com
      </a>{' '}
      as soon as possible to reactivate your account.
    </AccountPausedBanner>
  )
}

export { AccountStatus }
